module.exports = __webpack_public_path__ + "images/emoji/aries.4c1bd4a1ed8ca9eedee7.png";